const i18n = {
	selectItems: {
		1 : ["Должность", "Структурное подразделение"],
		0 : ["Пасада", "Структурнае падраздзяленне"]
	},
	placeholderItems: {
		1 : ["Начните вводить код/название должностей ответственных исполнителей", "Начните вводить код/название структурного подразделения"],
		0 : ["Пачніце ўводзіць код/назву пасад адказных выканаўцаў", "Пачніце ўводзіць код/назву структурнага падраздзялення"]
	},
	isRequired: {
		1 : "Поле обязательно для заполнения.",
		0 : "Поле абавязкова для запаўнення."
	},
	positionAtSigning: {
		1 : "Должность при подписывании",
		0 : "Пасада пры падпісанні"
	},
	positionAtSigningPlaceholder: {
		1 : "Введите должность отображаемую при подписывании",
		0 : "Увядзіце пасаду, якая адлюстроўваецца пры падпісванні"
	},
	positionAtSigningInfo: {
		1 : "Будет использоваться при генерации файлов сопроводительного письма и уведомления для заявителя",
		0 : "Будзе выкарыстоўвацца пры генерацыі файлаў суправаджальнага ліста і апавяшчэнні для заяўніка"
	},
	positionAtSigningError: {
		1 : "Некорректный ввод", 
		0 : "Некарэктны ўвод"
	}
}
export default i18n